export default __webpack_public_path__ + "static/media/saint-malo3.06b4dee8.jpg";